import { render, staticRenderFns } from "./SearchItemsProducts.vue?vue&type=template&id=22ca3c44&"
import script from "./SearchItemsProducts.vue?vue&type=script&lang=js&"
export * from "./SearchItemsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports